import { render, staticRenderFns } from "./BaseSpecialDetails.vue?vue&type=template&id=ea38a64c&scoped=true&"
import script from "./BaseSpecialDetails.vue?vue&type=script&lang=js&"
export * from "./BaseSpecialDetails.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpecialDetails.vue?vue&type=style&index=0&id=ea38a64c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea38a64c",
  null
  
)

export default component.exports